import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { postSignup } from "../utils/hubspot";

class Flow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeStep: 0,
			inputs: {},
			seen: [],
		};

		this.onStepCompleteHandler = this.onStepCompleteHandler.bind(this);
		this.onStepPreviousHandler = this.onStepPreviousHandler.bind(this);
	}

	componentWillMount() {
		const seen = [];
		const  childArray = Array.from(this.props.children);

		childArray.forEach((child, index) => {
			seen[index] = false;
		});

		this.setState({
			seen,
		});
	}

	onStepCompleteHandler(inputs) {
		this.setState(
			{
				inputs: {
					...this.state.inputs,
					...inputs,
				},
			},
			() => {
				const inputs = { ...this.state.inputs };

				// Hubspot requires first and last name
				if (inputs.name) {
					const fullName = inputs.name.split(" ");

					if (fullName.length === 1) {
						inputs.firstname = fullName[0];
						inputs.lastname = "";
					} else if (fullName.length >= 2) {
						inputs.firstname = fullName.shift();
						inputs.lastname = fullName.join(" ");
					}

					delete inputs.name;
				}
				postSignup(inputs);
				this.moveStep();
			}
		);
	}

	onStepPreviousHandler(evt) {
		evt.preventDefault();
		this.moveStep(-1);
	}

	moveStep(val = 1) {
		const activeStep = this.state.activeStep + val;

		if (this.props.processing) {
			return;
		}

		if (activeStep >= React.Children.count(this.props.children)) {
			this.props.onComplete(this.state.inputs);
			return;
		} else if (activeStep < 0) {
			return;
		}

		this.props.resetErrorMessage();

		const seen = this.state.seen.map((v, i) => v || i <= activeStep);

		this.setState({
			activeStep,
			seen,
		});
	}

	render() {
		const { title, className, errMsg } = this.props;
		const { activeStep } = this.state;
		const flowTitle = typeof title === "string" ? <h1>{title}</h1> : title;

		const children = React.Children.map(this.props.children, (child, i) =>
			React.cloneElement(child, {
				active: i === activeStep,
				seen: this.state.seen[i],
				processing: this.props.processing,
				onComplete: this.onStepCompleteHandler,
				onPrevious: this.onStepPreviousHandler,
				errMsg,
			})
		);

		return (
			<div className={cx("flow-container", { [className]: className })}>
				<div className="flow-title">{flowTitle}</div>
				{children}
			</div>
		);
	}
}

Flow.propTypes = {
	children: PropTypes.node.isRequired,
	onComplete: PropTypes.func.isRequired,
	title: PropTypes.node,
	className: PropTypes.string,
	processing: PropTypes.bool,
	errMsg: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	resetErrorMessage: PropTypes.func,
};

Flow.defaultProps = {
	onComplete: () => {},
};

export default Flow;



// WEBPACK FOOTER //
// ./src/components/Flow.js